(() => {
	const OFFSET = 120;

	const findTarget = (id) => {
		if (!id) return null;
		const escapeId = window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/["\\]/g, "\\$&");
		return document.getElementById(id) || document.querySelector(`[name="${escapeId}"]`);
	};

	const scrollToId = (id) => {
		const target = findTarget(id);
		if (!target) return;

		const doScroll = () => {
			const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
			window.scrollTo({ top, behavior: "auto" });
		};

		// Scroll once, then twice more after layout-shift triggers (sticky nav activating,
		// images loading, etc.) settle, so the final position always matches OFFSET.
		doScroll();
		requestAnimationFrame(() => requestAnimationFrame(doScroll));
		setTimeout(doScroll, 200);
	};

	document.addEventListener("click", (e) => {
		const link = e.target.closest('a[href*="#"]');
		if (!link) return;
		const url = new URL(link.href, location.href);
		if (url.pathname !== location.pathname || url.host !== location.host) return;
		if (!url.hash || url.hash === "#") return;
		const id = url.hash.slice(1);
		if (!findTarget(id)) return;

		e.preventDefault();
		history.pushState(null, "", url.hash);
		scrollToId(id);
	});

	const runInitial = () => {
		if (location.hash) scrollToId(location.hash.slice(1));
	};
	if (document.readyState === "complete") {
		setTimeout(runInitial, 0);
	} else {
		window.addEventListener("load", () => setTimeout(runInitial, 0));
	}
})();
